import { palette } from '@helsenorge/designsystem-react/theme/palette';
export const getIconColor = (name) => {
    if (name === 'black') {
        return palette.black;
    }
    else if (name === 'white') {
        return palette.white;
    }
    else if (name === 'plum') {
        return palette.plum600;
    }
    else if (name === 'neutral') {
        return palette.neutral600;
    }
    else if (name === 'kiwi') {
        return palette.kiwi600;
    }
    else if (name === 'cherry') {
        return palette.cherry600;
    }
    else if (name === 'blueberry') {
        return palette.blueberry600;
    }
    else if (name === 'banana') {
        return palette.banana600;
    }
    return palette.black;
};
